/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { AppBar, Popover, Tab, Tabs } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import { useLocation } from "react-router";
import HeaderActions from "@/src/components/Navigation/HeaderActions/HeaderActions";
import React, { useState } from "react";
import LinkTab from "@/src/components/LinkTab/LinkTab";
import NavigationBarLogo from "@/src/components/Navigation/NavigationBar/NavigationBarLogo";
import SubnavigationTabs from "@/src/components/Navigation/NavigationBar/SubnavigationTabs";

export type NavigationBarDesktopNonAuthenticatedProps = {
  hideActions?: boolean;
  clickableLogo?: boolean;
  mainNavigationItems: Array<
    (
      | { type: "link"; to: string }
      | {
          type: "category";
          categoryMapping: Array<{ to: string; label: string }>;
        }
    ) & { label: string; value: string | null }
  >;
};

export default function NavigationBarDesktopNonAuthenticated({
  mainNavigationItems,
  hideActions,
  clickableLogo = true,
}: NavigationBarDesktopNonAuthenticatedProps) {
  const { pathname } = useLocation();
  const [toolbarRef, setToolbarRef] = useState<HTMLDivElement | null>(null);

  const mainNavigationTabCategory = mainNavigationItems[0];

  const mainNavValue = mainNavigationItems.find((tab) => {
    if (tab.type === "category") {
      return tab.categoryMapping.find((link) => pathname.includes(link.to));
    }

    return pathname.includes(tab.to);
  })?.value;

  const secondLevelNavValue =
    mainNavigationTabCategory?.type === "category" && mainNavigationTabCategory.categoryMapping.find((tab) => pathname.includes(tab.to))?.to;

  const [productCategoryPopoverOpen, setProductCategoryPopoverOpen] = useState(!!secondLevelNavValue);

  return (
    <>
      <AppBar sx={(theme) => ({ backgroundColor: theme.palette.background.default })} elevation={0}>
        <Toolbar sx={{ justifyContent: "space-between" }} ref={(ele) => setToolbarRef(ele)}>
          <NavigationBarLogo clickableLogo={clickableLogo} />
          <Tabs value={mainNavValue} aria-label="Hauptnavigation" role="navigation">
            {mainNavigationItems.map((tab) => {
              if (tab.type === "link") {
                return <LinkTab key={tab.to} label={tab.label} to={tab.to} value={tab.to} selected={tab.to === mainNavValue} />;
              }

              return <Tab label={tab.label} value={tab.value} onClick={() => setProductCategoryPopoverOpen(true)} />;
            })}
          </Tabs>
          {!hideActions && <HeaderActions />}
        </Toolbar>
      </AppBar>
      <Popover
        elevation={0}
        anchorEl={toolbarRef}
        open={!!toolbarRef && productCategoryPopoverOpen}
        disableScrollLock
        transitionDuration={0}
        sx={{
          pointerEvents: "none",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        slotProps={{
          paper: {
            sx: (theme) => ({
              pointerEvents: "auto",
              marginTop: "1rem",
              border: `1px solid ${theme.palette.divider}`,
            }),
          },
        }}
      >
        <SubnavigationTabs value={secondLevelNavValue} items={mainNavigationTabCategory?.type === "category" ? mainNavigationTabCategory.categoryMapping : []} />
      </Popover>
    </>
  );
}
